export const AppConfig = {
    SERVICE_BASE_URL: process.env.REACT_APP_SERVICE_BASE_URL,

    AUTH_ENABLED: process.env.REACT_APP_AUTH_ENABLED === 'true',
    AUTH_STORE_IN_COOKIE: process.env.REACT_APP_AUTH_STORE_IN_COOKIE === 'true',
    AUTH_API_KEY: process.env.REACT_APP_AUTH_API_KEY,
    AUTH_TOKEN_KEY: 'BioLine-Auth-Token',
    AUTH_TOKEN_EXPIRATION_KEY: 'BioLine-Auth-Token-Expiration',
};